__turbopack_context__.v({
  "disclosure": "DisclosureNote-module__TwAQ9a__disclosure",
  "lead": "DisclosureNote-module__TwAQ9a__lead",
  "message": "DisclosureNote-module__TwAQ9a__message",
  "prominent": "DisclosureNote-module__TwAQ9a__prominent",
});
